

<div class="h-100 center">
    {{ 'You have no noted' | appTranslate | async }}
  </div>
  